// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Anytime Fitness. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
